import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS, WARNING_COLORS } from 'asterX-UI'
import CarImg from 'assets/img/car_placeholder.jpg'
import { Modal } from 'asterX-UI/Modals'
import CarData from 'components/Mobile/Car/CarData'

const useStyle = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 10,
    // backgroundColor: GRAY_COLORS[50],
    gap: 12,
    backgroundColor: GRAY_COLORS['50']
  },
  carPhoto: {
    width: 136,
    height: 96,
    borderRadius: '10px 0px 0px 10px',
    position: 'relative'
  },
  price: {
    padding: '1px 6px',
    borderRadius: '0px 5px 0px 10px',
    position: 'absolute',
    bottom: 0,
    left: 0,
    backgroundColor: WARNING_COLORS[300],
    color: GRAY_COLORS[800],
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '18px'
  },
  carInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    width: '100%'
  },
  title: {
    color: GRAY_COLORS[700],
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '18px'
  },
  vin: {
    color: GRAY_COLORS[700],
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px'
  },
  branch: {
    color: GRAY_COLORS[500],
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px'
  }
}))
const CarCard = ({ car }) => {
  const classes = useStyle()
  const [open, setOpen] = useState(false)
  const handleCarClick = () => {
    setOpen(!open)
  }
  return (
    <>
      <div className={classes.root} onClick={handleCarClick}>
        <div className={classes.carPhoto}>
          <img className={classes.carPhoto} src={car?.photos?.[0] || CarImg} />
          <div className={classes.price}>
            {car?.discountApproveRopFullName
              ? car?.discountValue?.toString()?.thousandSeparator()
              : car?.price?.toString()?.thousandSeparator()}{' '}
            ₸
          </div>
        </div>
        <div className={classes.carInfo}>
          <div className={classes.title}>{`${
            typeof car?.marka === 'string' ? car?.marka : car?.marka?.name
          } ${typeof car?.model === 'string' ? car?.model : car?.model?.name} ${
            car?.year
          }`}</div>
          <div className={classes.vin}>{car?.vin}</div>
          <div className={classes.branch}>
            {typeof car?.branch === 'string' ? car?.branch : car?.branch?.name}
          </div>
        </div>
      </div>
      {open && (
        <Modal fullScreen open={open} onClose={handleCarClick}>
          <CarData vin={car.vin} onClose={handleCarClick} />
        </Modal>
      )}
    </>
  )
}
export default CarCard
